import React from 'react';
import { Box, Stack, Typography, Link } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

export const NoAuthorizeClient = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}>
      <Box sx={{ maxWidth: 600, width: '100%', px: 2 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <LockIcon color="primary" sx={{ fontSize: 'clamp(6rem, 20vw, 12rem)' }} />

          <Typography variant="h5" fontWeight="bold">
            Plataforma temporalmente inhabilitada
          </Typography>

          <Typography>Hemos detectado pagos pendientes asociados a su cuenta.</Typography>

          <Typography>Para validar su estado y ponerse al día, por favor ingrese a:</Typography>

          <Typography>
            <Link href="https://mili.com.co/cliente/login" underline="hover" color="primary">
              https://mili.com.co/cliente/login
            </Link>
          </Typography>

          <Typography>
            Una vez regularizados los pagos, la plataforma se activará nuevamente de forma
            automática.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
